import axios from "axios";
import { message } from "antd";
import { baseUrl, showConsole } from "./env";
import { errorNotification } from "../components/Toast";

// Axios instance
const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// ✅ Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && config.headers) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let networkErrorShown = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorMsg = error.response?.data?.error || "Something went wrong!";

    if ([400, 404, 500].includes(status || 0)) {
      errorNotification(errorMsg);
    } else if (
      error.message === "Network Error" ||
      error.message.includes("ERR_INTERNET_DISCONNECTED")
    ) {
      if (!networkErrorShown) {
        networkErrorShown = true;
        errorNotification("Network Error Occurred");
        // Reset after 3 seconds (so the message can appear again later)
        setTimeout(() => {
          networkErrorShown = false;
        }, 3000);
      }
    } else {
      errorNotification(errorMsg);
    }

    return Promise.reject(error);
  }
);

// ✅ HTTP utility methods
const http = {
  post: (path, body) =>
    axiosInstance.post(path, body).then((res) => res.data),

  get: (path) =>
    axiosInstance.get(path).then((res) => res.data),

  postFormData: (path, body) =>
    axiosInstance
      .post(path, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  put: (path, body) =>
    axiosInstance.put(path, body).then((res) => res.data),

  putFormData: (path, body) =>
    axiosInstance
      .put(path, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  delete: (path) =>
    axiosInstance.delete(path).then((res) => res.data),

  patch: (path, body) =>
    axiosInstance.patch(path, body).then((res) => res.data),

  resetPassword: (path, body) => {
    return new Promise(async (resolve, reject) => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("verifyToken")}`,
      };

      try {
        const res = await axios.patch(`${baseUrl}/${path}`, body, { headers });
        resolve(res.data);
      } catch (err) {
        reject(err);
      }
    });
  },

  patchFormData: (path, body) =>
    axiosInstance
      .patch(path, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),
};

// ✅ Error handler
const errorResponseHandler = (error) => {
  if (showConsole && error.response?.data) {
    console.log(error.response.data?.message);
  }
};

export { http, errorResponseHandler };
